module.exports = __webpack_public_path__ + "static/media/jetson_one_render_24.a69e8082.jpg";